export const SIGNUP_RATE_LIMIT_ERROR_CODE = 'signup-rate-limited';
export const SIGNUP_RATE_LIMIT_MESSAGE = 'Too many signup attempts. Please try again later.';
